import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/dashboard";
  usePageTitle("Sign in — Olivia Does");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(form.email, form.password);
    setBusy(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name.split(" ")[0]}.`);
      navigate(next);
    } else {
      setError(res.error || "Incorrect email or password.");
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md od-card p-8">
        <h1 className="font-display text-3xl">Log In</h1>
        <p className="text-sm text-[#78716C] mt-2">One account for customers, trades and staff.</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          {error && (
            <div data-testid="login-error" className="rounded-lg border border-[#993333]/30 bg-[#993333]/10 text-[#993333] text-sm px-4 py-3">
              {error}
            </div>
          )}
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#78716C]">Email</Label>
            <Input data-testid="login-email" type="email" required value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} className="mt-2 rounded-xl border-[#E2DBD6]" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#78716C]">Password</Label>
            <Input data-testid="login-password" type="password" required value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})} className="mt-2 rounded-xl border-[#E2DBD6]" />
          </div>
          <Button data-testid="login-submit" disabled={busy} type="submit" className="w-full rounded-full bg-[#2A2624] hover:bg-[#1E1A18] py-6">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-[#78716C] mt-4 text-center">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="od-link font-medium">Forgot your password?</Link>
        </p>
        <p className="text-sm text-[#78716C] mt-2">No account? <Link to="/register" className="od-link font-medium">Join Olivia</Link></p>
      </div>
    </div>
  );
}
